// ===========================================================================
// Charge Capture (Módulo N) — entry point.
//
// Prototipo. Habilitado por la env var REACT_APP_ENABLE_CHARGE_CAPTURE=true.
// Ver docs/modulos/ChargeCapture/MODULO_N_CHARGE_CAPTURE.md.
// ===========================================================================
import ChargeCapturePage from "./pages/ChargeCapturePage";
import ChargeSlipWorkspacePage from "./pages/ChargeSlipWorkspacePage";

export { ChargeCapturePage, ChargeSlipWorkspacePage };
export { CHARGE_CAPTURE_ENABLED } from "./common/constants";
export default ChargeCapturePage;
